module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f872c1456958a6110d3bd9d6c4340297.png";